export const SITE_NAME = "마이리틀클래식";

export const seoRoutes = {
  "/": {
    title: "영유아 클래식 공연 | 마이리틀클래식",
    description: "전문 연주자의 라이브 연주와 참여형 진행으로 완성하는 영유아 맞춤 클래식 공연입니다.",
    image: "/images/hero-institution.webp",
    imageWidth: 1800,
    imageHeight: 1013,
  },
  "/institution-performance": {
    title: "찾아가는 클래식 공연·기관 행사 섭외 | 마이리틀클래식",
    description: "어린이집, 유치원, 공공기관과 가족행사를 위한 찾아가는 영유아 클래식 공연을 안내합니다.",
    image: "/images/hero-institution.webp",
    imageWidth: 1800,
    imageHeight: 1013,
  },
  "/group-visit": {
    title: "동탄 어린이집·유치원 단체관람 | 마이리틀클래식",
    description: "동탄 영유아 전용 공연장에서 만나는 어린이집·유치원 단체관람 프로그램과 관람 기록, 비용을 안내합니다.",
    image: "/images/venue-wide.webp",
    imageWidth: 1800,
    imageHeight: 1002,
  },
  "/venue": {
    title: "영유아를 위한 공연장은 무엇이 다를까 | 동탄 마이리틀클래식",
    description: "Theatre for Early Years(TEY)의 관점에서 낮은 무대, 가까운 객석과 자유로운 반응을 설명하고 이를 구현한 동탄 영유아 클래식 공연장을 소개합니다.",
    image: "/images/venue-starry-night.jpg",
    imageWidth: 1810,
    imageHeight: 1080,
  },
  "/guide/field-trip-checklist": {
    title: "어린이집 현장학습 장소 고르는 법 7가지 | 마이리틀클래식",
    description: "이동 시간, 버스 하차 동선, 단독 운영 여부, 인원 정산 기준까지. 영유아 현장학습 장소를 정하기 전 확인할 일곱 가지를 정리했습니다.",
    image: "/images/storytelling.webp",
    imageWidth: 1080,
    imageHeight: 1350,
  },
  "/guide/first-classic-age": {
    title: "영유아 클래식 공연, 몇 살부터 괜찮을까 | 마이리틀클래식",
    description: "돌 전후부터 만 5세까지, 연령대별로 아이가 공연장에서 실제로 무엇을 하는지와 무엇을 기대하면 좋은지를 발달 단계에 따라 안내합니다.",
    image: "/images/participation.webp",
    imageWidth: 1080,
    imageHeight: 1087,
  },
  "/about": {
    title: "마이리틀클래식 소개 | 마이리틀클래식",
    description: "아이의 첫 클래식 경험을 설계하는 마이리틀클래식의 공연 철학을 소개합니다.",
    image: "/images/media-art-live.jpg",
    imageWidth: 4000,
    imageHeight: 2226,
  },
  "/inquiry": {
    title: "공연 문의 | 마이리틀클래식",
    description: "기관·행사 공연 섭외 또는 어린이집·유치원 단체관람을 문의하세요.",
    image: "/images/hero-institution.webp",
    imageWidth: 1800,
    imageHeight: 1013,
  },
  "/privacy": {
    title: "개인정보처리방침 | 마이리틀클래식",
    description: "마이리틀클래식의 문의 정보 처리 및 개인정보 보호 방침을 안내합니다.",
    image: "/images/hero-institution.webp",
    imageWidth: 1800,
    imageHeight: 1013,
  },
};

export function seoForPath(path = "/") {
  return seoRoutes[path] || {
    title: "페이지를 찾을 수 없습니다 | 마이리틀클래식",
    description: "요청한 페이지를 찾을 수 없습니다.",
    image: "/images/hero-institution.webp",
    imageWidth: 1800,
    imageHeight: 1013,
    noindex: true,
  };
}
